import React, { useMemo } from 'react';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';

import { useAppStore } from 'store/useAppStore';
import { useMessengerStore } from 'store/useMessengerStore';

const Messenger = () => {
	// Use app's store
	const [user, setMessenger] = useAppStore(state => [state.user, state.setMessenger]);

	// Use messenger's store
	const conversations = useMessengerStore(state => state.conversations);

	// Count unread messages
	const unread = useMemo(() => {
		return conversations?.reduce((total, conversation) => {
			return total + conversation.messages?.filter(message => !message.readby.some(recipient => recipient.userId === user.id))?.length;
		}, 0);
	}, [user, conversations]);

	return (
		<span className="relative w-10 h-10 text-center leading-10 cursor-pointer" onClick={setMessenger}>
			<Icon icon="chat" className="text-xl text-neutral-800 dark:text-neutral-400" />

			<Show if={unread}>
				<div className="absolute top-0 right-0 w-5 h-5 leading-5 bg-emerald-500 text-xs font-bold text-white rounded-full text-center animate-fade-in">
					{unread > 9 ? '9+' : unread}
				</div>
			</Show>
		</span>
	);
};

export default Messenger;